import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function dateValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value || control.value === '') {
      return null;
    }

    const valid =
      control.value instanceof Date ||
      /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)((-(\d{2}):(\d{2})|Z)?)$/.test(control.value);
    return !valid ? { invalidDate: { value: control.value, msg: 'Nevalidný dátumový formát.' } } : null;
  };
}
